import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context";
import { useTranslation } from "react-i18next";
import { getMyBooks } from "../../api";
import { STRINGS } from "../../constants";
import { IMAGES } from "../../assets";
import { useNavigate } from "react-router-dom";
import BookCard from "../../components/book/BookCard";

const MyBook = (props) => {
  const { user, activeLanguage } = useContext(AuthContext);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [bookItem, setBookItem] = useState([]);
  const [isError, setIsError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    onMyBookList();
  }, []);

  async function onMyBookList() {
    const params = {
      userId: user?.userInfo?._id,
    };

    setIsLoading(true);
    const result = await getMyBooks(params);
    setIsLoading(false);

    if (result?.status) {
      const response = result?.data?.data ?? [];
      setBookItem(response);
      if (response?.length == 0) {
        setIsError(t(STRINGS?.no_books_found));
      }
    } else {
      setIsError(result?.error);
    }
  }

  return (
    <div>
      <div className="flex flex-wrap items-center justify-center">
        <h2 className="mx-auto text-lg font-bold">{t(STRINGS?.myBooks)}</h2>
      </div>
      {isLoading ? (
        <div className="flex items-center justify-center mt-10">
          <p className="text-center">Loading...</p>
        </div>
      ) : (
        <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 mt-4 gap-4">
          {bookItem?.map((item) => {
            return (
              <div key={item?._id}>
                <BookCard
                  isProgerss={true}
                  percentage={item?.books?.readingPercent}
                  img={
                    item?.bookImage ??
                    item?.eBookData?.bookImage ??
                    IMAGES?.bookLogo
                  }
                  name={item?.bookName ?? item?.eBookData?.bookName}
                  price={
                    activeLanguage === "Marathi"
                      ? "₹ " +
                        new Intl.NumberFormat("mr", {
                          maximumSignificantDigits: 2,
                        }).format(item?.eBookData?.price ?? item.price)
                      : "₹ " + (item.price ?? item?.eBookData?.price)
                  }
                  rating={item?.overallRating ?? item?.eBookData?.overallRating}
                  onClick={() =>
                    navigate(
                      `/aboutbook/${item?._id ?? item?.eBookData?._id}`,
                      {
                        state: { item: item?.eBookData },
                      }
                    )
                  }
                  type="horizontal"
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyBook;
